import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import WhatsAppFloating from "../components/WhatsAppFloating";
const API_ENDPOINTS = {
  contactSendEmail: 'https://gift-contactsendemail-336444799661.us-central1.run.app',
};

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);


  // ✅ ensure page starts at top when navigating here
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await fetch(API_ENDPOINTS.contactSendEmail, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (data.success) {
      setSubmitted(true);
    } else {
      alert('❌ Error al enviar el mensaje. Por favor intentá de nuevo.');
    }
  } catch (error) {
    console.error('Error sending contact email:', error);
    alert('❌ Error al enviar el mensaje. Por favor intentá de nuevo.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            {/* ✅ consistent internal page size */}
            <Logo className="h-12 sm:h-14" />

            <Link
              to="/"
              className="text-sm text-neutral-600 hover:text-accent-600 transition-colors"
            >
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-gradient-to-r from-accent-500 to-primary-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-display font-bold mb-4">
            Contacto
          </h1>
          <p className="text-xl text-white/90">
            Estamos para ayudarte. Escribinos!
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-6">
              Información de Contacto
            </h2>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="bg-accent-100 p-3 rounded-lg">
                  <svg className="w-6 h-6 text-accent-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-900 mb-1">Email</h3>
                  <a href="mailto:info@sobredigital.net" className="text-accent-600 hover:text-accent-700">
                    info@sobredigital.net
                  </a>
                </div>
              </div>

              {/* <div className="flex items-start space-x-4">
                <div className="bg-accent-100 p-3 rounded-lg">
                  <svg className="w-6 h-6 text-accent-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-900 mb-1">Ubicación</h3>
                  <p className="text-neutral-600">Corrientes, Argentina</p>
                </div>
              </div> */}
<div className="flex items-start space-x-4">
  <div className="bg-accent-100 p-3 rounded-lg">
    {/* Instagram icon */}
    <svg className="w-6 h-6 text-accent-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M16 2H8a6 6 0 00-6 6v8a6 6 0 006 6h8a6 6 0 006-6V8a6 6 0 00-6-6z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M12 16a4 4 0 100-8 4 4 0 000 8z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M17.5 6.5h.01" />
    </svg>
  </div>
  <div>
    <h3 className="font-semibold text-neutral-900 mb-1">Instagram</h3>
    <a
      href="https://instagram.com/sobredigitalok"
      target="_blank"
      rel="noopener noreferrer"
      className="text-accent-600 hover:text-accent-700"
    >
      @sobredigitalok
    </a>
  </div>
</div>

              <div className="flex items-start space-x-4">
                <div className="bg-accent-100 p-3 rounded-lg">
                  <svg className="w-6 h-6 text-accent-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-900 mb-1">Horario de Atención</h3>
                  <p className="text-neutral-600">Lunes a Viernes: 9:00 - 18:00</p>
                  <p className="text-neutral-600">Respondemos emails 24/7</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-accent-50 rounded-lg border border-accent-200">
              <h3 className="font-semibold text-accent-900 mb-2">Tiempo de Respuesta</h3>
              <p className="text-sm text-accent-800">
                Respondemos todas las consultas en menos de <strong>24 horas hábiles</strong>.
                
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            {!submitted ? (
              <div className="bg-white rounded-2xl shadow-xl p-8">
                <h2 className="text-2xl font-display font-bold text-neutral-900 mb-6">
                  Envianos un Mensaje
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-2">
                      Nombre *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="input-field"
                      placeholder="Tu nombre completo"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="input-field"
                      placeholder="tu@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-2">
                      Asunto *
                    </label>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="input-field"
                    >
                      <option value="">Seleccioná un tema</option>
                      <option value="crear-lista">Quiero crear mi lista</option>
                      <option value="problema-tecnico">Problema técnico</option>
                      <option value="pago">Consulta sobre pagos</option>
                      <option value="modificar-lista">Modificar mi lista</option>
                      <option value="otro">Otro</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-2">
                      Mensaje *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      className="input-field resize-none"
                      placeholder="Contanos en qué podemos ayudarte..."
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full btn-primary text-lg"
                  >
                    {loading ? 'Enviando...' : 'Enviar Mensaje'}
                  </button>
                </form>
              </div>
            ) : (
              <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="text-6xl mb-4">✉️</div>
                <h3 className="text-2xl font-display font-bold text-neutral-900 mb-3">
                  ¡Mensaje Enviado!
                </h3>
                <p className="text-neutral-600 mb-6">
                  Recibimos tu consulta. Te responderemos a <strong>{formData.email}</strong> en menos de 24 horas.
                </p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="btn-secondary"
                >
                  Enviar otro mensaje
                </button>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* Footer (consistent light style) */}
      <WhatsAppFloating />
      <footer className="bg-white border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-neutral-500">
              © {new Date().getFullYear()} SobreDigital. Todos los derechos reservados.
            </p>
            <Link
              to="/"
              className="text-sm text-neutral-600 hover:text-accent-600 transition-colors"
            >
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
